import React, { useCallback, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Tabs } from 'antd';
import DeleteModal from '../../components/modals/DeleteModal';
import { useLocation, useNavigate } from 'react-router-dom';
import ContentLayout from '../../layout/ContentLayout';
import TableSection from '../../components/tables/TableSection';
import useResize from '../../hooks/useResize';
import { userTypeTranslations } from '../../constants/user-constants';
import { useAuth } from '../../context/useAuth';
import {
  activateMedic,
  deleteClinic,
  deleteMedic, exportClinics,
  fetchAllClinics,
  fetchClinics,
  fetchMedics,
} from '../../api/medics-api';
import CreateMedicModal from '../../components/modals/CreateDoctorModal';
import CreateClinicModal from '../../components/modals/CreateClinicModal';
import { toast, ToastContainer } from 'react-toastify';
import styles from '../../styles/users.module.scss';
import Search from 'antd/es/transfer/search';
import { Button, Dropdown } from 'antd';
import {exportUsers, hardDeleteUser} from "../../api/user-api";
import Spinner from '../../components/elements/Spinner/Spinner';
import {
  adminAwardLoyaltyPoints,
  adminDeductLoyaltyPoints,
} from '../../api/loyalty-api';
import AwardLoyaltyPointsModal from '../../components/modals/AwardLoyaltyPointsModal';
import DeductLoyaltyPointsModal from '../../components/modals/DeductLoyaltyPointsModal';
import { usePermissions } from '../../context/PermissionsContext';

const userFilterSections = [
  // {
  //   title: 'Tip',
  //   type: 'type',
  //   items: [
  //     { key: 'individual', label: 'Fizičko lice' },
  //     { key: 'company', label: 'Pravno lice' },
  //   ],
  // },
  {
    title: '',
    type: 'Status',
    items: [
      { key: 'active', label: 'Aktivan' },
      { key: 'inactive', label: 'Neaktivan' },
      // { key: 'manager', label: 'Menadžer' },
    ],
  },
  // {
  //   title: 'Status',
  //   type: 'status',
  //   items: [
  //     { key: 'active', label: 'Aktivan' },
  //     {
  //       key: ['pending_verification', 'pending_admin_verification'],
  //       label: 'Čeka verifikaciju',
  //       type: 'status',
  //     },
  //     { key: 'suspended', label: 'Suspendovan' },
  //     { key: 'archived', label: 'Arhiviran' },
  //     { key: 'pre_registration', label: 'Registracija nedovršena' },
  //   ],
  // },
];

const tabItems = [
  {
    key: 'svi',
    label: 'Mentori',
  },
  {
    key: 'clinic',
    label: 'Organizacije',
  },
  // {
  //   key: 'statistics',
  //   label: 'Statistika',
  // },
];

export default function Medics({ embedded = false, initialTab: forcedInitialTab } = {}) {
  const { user } = useAuth();
  const { canAll } = usePermissions();
  const [searchMedics, setSearchMedics] = useState('');
  const [searchClinic, setSearchClinic] = useState('');
  const [debouncedSearchMedics, setDebouncedSearchMedics] = useState('');
  const [debouncedSearchClinic, setDebouncedSearchClinic] = useState('');

  const [clinics, setClinics] = useState([]);
  const [isCreateMedicModalOpen, setIsCreateMedicModalOpen] = useState(false);
  const [isCreateClinicModalOpen, setIsCreateClinicModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [medics, setMedics] = useState([]);
  const [currentPageMedics, setCurrentPageMedics] = useState(1);
  const [totalPagesMedics, setTotalPagesMedics] = useState(1);
  const [totalMedics, setTotalMedics] = useState(0);
  const [currentPageClinics, setCurrentPageClinics] = useState(1);
  const [totalPagesClinics, setTotalPagesClinics] = useState(1);
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [done, setDone] = useState(false);
  const [message, setMessage] = useState('');
  const [userForVerification, setUserForVerification] = useState(null);
  const [isUserVerificationModalOpen, setIsUserVerificationModalOpen] =
    useState(false);
  const width = useResize();

  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);

  // When embedded (rendered as a korisnici.js tab body), the parent page owns the
  // `?tab=` query param for its own tab state — reading it here would misinterpret
  // e.g. `?tab=mentori` as this component's own tab key. Use the forced prop instead,
  // and never read from the URL in that case (safe since the internal switcher that
  // would otherwise call setActiveTab is hidden too — see the render below).
  const initialTab = embedded ? (forcedInitialTab || 'svi') : (queryParams.get('tab') || 'svi');
  const [activeTab, setActiveTab] = useState(initialTab);
  const [allClinics, setAllClinics] = useState([]);

  const [filter, setFilter] = useState({
    status: null,
    organizationStatus: null,
  });
  console.log('filter', filter);

  const vipStatusOptions = [
    { label: 'Neaktivan', value: 'inactive' },
    { label: 'Na čekanju', value: 'pending' },
    { label: 'Aktivan', value: 'active' },
    { label: 'Istekao', value: 'expired' },
    { label: 'Otkazan', value: 'cancelled' },
  ];

  const organizationStatusOptions = [
    { label: 'Aktivan', value: 'aktivan' },
    { label: 'Neaktivan', value: 'neaktivan' },
  ];

  const medicFilterOptions = [
    { label: 'Aktivan', value: 'ACTIVE' },
    { label: 'Deaktiviran', value: 'INACTIVE' },
  ];

  const onSearchMedics = (value) => {
    setSearchMedics(value);
  };

  const onSearchClinics = (value) => {
    setSearchClinic(value);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchMedics(searchMedics);
      // Reset to page 1 when search changes
      if (searchMedics !== debouncedSearchMedics) {
        setCurrentPageMedics(1);
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [searchMedics, debouncedSearchMedics]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchClinic(searchClinic);
      // Reset to page 1 when search changes
      if (searchClinic !== debouncedSearchClinic) {
        setCurrentPageClinics(1);
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [searchClinic, debouncedSearchClinic]);

  const handleFetchAllClinics = async () => {
    const { data, success, message } = await fetchAllClinics();

    if (!success) {
      toast.error(message || 'Error while fetching the data!');
      return;
    }

    const payload_data =
      data && data.clinics && data.clinics.length > 0
        ? data.clinics.map((i) => {
            return {
              label: i.name,
              value: i,
            };
          })
        : [];

    const array_data = [{ label: 'Select', value: null }, ...payload_data];

    setAllClinics(array_data);
  };

  const loadClinics = useCallback(async () => {
    let appliedFilters = { ...filter };

    const { data, success, message } = await fetchClinics({
      page: currentPageClinics,
      limit: 10,
      filter: appliedFilters,
      search: debouncedSearchClinic,
      isActive:
        filter.organizationStatus === 'aktivan'
          ? true
          : filter.organizationStatus === 'neaktivan'
            ? false
            : null,
    });

    if (success) {
      setClinics(data.clinics);
      setTotalPagesClinics(data?.pagination?.totalPages);
    } else {
      console.log(message || 'Error while fetching the clinics.');
    }
    setInitialLoading(false);
  }, [filter, debouncedSearchClinic, currentPageClinics, activeTab]);
  console.log('currentPageClinics', currentPageClinics);

  const handleFilterChange = (newFilter) => {
    setFilter((prev) => {
      const updated = { ...prev, ...newFilter };
      const same = Object.keys(updated).every(
        (key) => updated[key] === prev[key]
      );
      return same ? prev : updated;
    });
  };

  const getFilteredSections = (tabKey) => {
    if (tabKey === 'svi') return userFilterSections;

    const map = {
      rola: 'role',
      status: 'status',
      verifikacija: 'type',
      tip: 'type',
    };

    const filterType = map[tabKey];
    if (!filterType) return [];

    return userFilterSections.filter((section) => section.type === filterType);
  };

  // TODO:
  const loadMedics = useCallback(async () => {
    let appliedFilters = { ...filter };

    if (activeTab === 'verifikacija') {
      appliedFilters.documentVerified = 'false';
      appliedFilters.type = 'company';
      appliedFilters.status = 'pending_admin_verification';
    } else if (activeTab === 'arhivirani') {
      appliedFilters.status = 'archived';
    } else if (activeTab === 'odbijeni') {
      appliedFilters.status = 'rejected';
    }

    const { data, success, message } = await fetchMedics({
      page: currentPageMedics,
      limit: 10,
      filter: appliedFilters,
      search: debouncedSearchMedics,
      status: filter.status || null,
    });

    if (success) {
      setMedics(data.doctors);
      setTotalPagesMedics(data?.pagination?.totalPages);
      setTotalMedics(data?.pagination?.totalItems ?? 0);
    } else {
      console.log(message || 'Error while fetching the users.');
    }
    setInitialLoading(false);
  }, [filter, debouncedSearchMedics, currentPageMedics, activeTab]);

  useEffect(() => {
    handleFetchAllClinics();
  }, []);
  console.log('medics', medics);

  useEffect(() => {
    loadMedics();
    // eslint-disable-next-line
  }, [filter, debouncedSearchMedics, currentPageMedics, activeTab]);

  useEffect(() => {
    loadClinics();
  }, [currentPageClinics, debouncedSearchClinic, filter, activeTab]);

  useEffect(() => {
    setFilter((prev) => {
      if (Object.keys(prev).length > 0) return {};
      return prev;
    });
    setCurrentPageMedics(1);
    setCurrentPageClinics(1);
    setSearchMedics('');
    setSearchClinic('');
  }, [activeTab]);

  useEffect(() => {
    setIsUserVerificationModalOpen(!!userForVerification);
  }, [userForVerification]);

  const handleCreateMedicModalClose = () => {
    setIsCreateMedicModalOpen(false);
    setDone(false);
    setCurrentPageMedics(1);
    setSearchMedics('');
    loadMedics();
  };

  const handleCreateClinicModalClose = () => {
    setIsCreateClinicModalOpen(false);
    setDone(false);
    setCurrentPageClinics(1);
    setSearchClinic('');
    loadClinics();
  };

  const handleDeleteModalClose = () => {
    setIsDeleteModalOpen(false);
    setDone(false);
  };

  const handleTabChange = (key) => {
    setActiveTab(key);
    const params = new URLSearchParams(location.search);
    params.set('tab', key);
    navigate({ search: params.toString() }, { replace: true });
  };

  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [deleteUserId, setDeleteUser] = useState(null);
  const [deleteUserName, setDeleteUserName] = useState(null);

  const [isHardDeleteModalOpen, setIsHardDeleteModalOpen] = useState(false);
  const [isHardDeleteLoading, setIsHardDeleteLoading] = useState(false);
  const [hardDeleteUserId, setHardDeleteUserId] = useState(null);
  const [hardDeleteUserName, setHardDeleteUserName] = useState(null);

  const [isActivateModalOpen, setIsActivateModalOpen] = useState(false);
  const [activateUserId, setActivateUser] = useState(null);
  const [activateUserName, setActivateUserName] = useState(null);
  const [isActivateLoading, setIsActivateLoading] = useState(false);

  const [isAwardPointsModalOpen, setIsAwardPointsModalOpen] = useState(false);
  const [awardPointsUser, setAwardPointsUser] = useState(null);
  const [loadingAwardPoints, setLoadingAwardPoints] = useState(false);
  const [isDeductPointsModalOpen, setIsDeductPointsModalOpen] = useState(false);
  const [deductPointsUser, setDeductPointsUser] = useState(null);
  const [loadingDeductPoints, setLoadingDeductPoints] = useState(false);

  const handleAwardPoints = async (points) => {
    setLoadingAwardPoints(true);
    const userId = awardPointsUser._id;
    const prevPoints = awardPointsUser.loyaltyPoints ?? 0;

    setMedics((prev) =>
      prev.map((u) => (u._id === userId ? { ...u, loyaltyPoints: prevPoints + points } : u))
    );
    setIsAwardPointsModalOpen(false);
    setAwardPointsUser(null);

    const { success, message } = await adminAwardLoyaltyPoints(userId, points);

    if (!success) {
      setMedics((prev) =>
        prev.map((u) => (u._id === userId ? { ...u, loyaltyPoints: prevPoints } : u))
      );
      toast.error(message || 'Greška pri dodavanju poena');
    } else {
      toast.success('Poeni uspešno dodati');
    }

    setLoadingAwardPoints(false);
  };

  const handleDeductPoints = async (points, deductionMessage) => {
    setLoadingDeductPoints(true);
    const userId = deductPointsUser._id;
    const prevPoints = deductPointsUser.loyaltyPoints ?? 0;

    setMedics((prev) =>
      prev.map((u) =>
        u._id === userId ? { ...u, loyaltyPoints: Math.max(0, prevPoints - points) } : u
      )
    );
    setIsDeductPointsModalOpen(false);
    setDeductPointsUser(null);

    const { success, message } = await adminDeductLoyaltyPoints(
      userId,
      points,
      deductionMessage
    );

    if (!success) {
      setMedics((prev) =>
        prev.map((u) => (u._id === userId ? { ...u, loyaltyPoints: prevPoints } : u))
      );
      toast.error(message || 'Greška pri oduzimanju poena');
    } else {
      toast.success('Poeni uspešno oduzeti');
    }

    setLoadingDeductPoints(false);
  };

  const handleDeleteMedic = async () => {
    const userId = deleteUserId;
    toast.loading('Brisanje...');

    setIsDeleteLoading(true);
    const { success, message } =
      activeTab === 'svi'
        ? await deleteMedic(userId)
        : await deleteClinic(userId);

    if (!success) {
      setMessage(message);
      toast.dismiss();
      toast.error('Došlo je do greške prilikom brisanja.');
    } else {
      setIsDeleteModalOpen(false);
      setMedics((prev) => prev.filter((user) => user._id !== userId));
      toast.dismiss();
      toast.success(
        `${activeTab === 'svi' ? 'Mentor je uspešno izbrisan.' : 'Organizacija je uspešno izbrisana.'}`
      );

      if (activeTab === 'svi') loadMedics();
      else if (activeTab == 'clinic') loadClinics();

      setDone(true);
      setTimeout(() => {
        setDeleteUser(null);
      }, 1000);
    }

    setIsDeleteLoading(false);
  };

  const handleHardDeleteModalClose = () => {
    setIsHardDeleteModalOpen(false);
  };

  const handleHardDeleteMedic = async () => {
    const userId = hardDeleteUserId;
    toast.loading('Trajno brisanje...');

    setIsHardDeleteLoading(true);
    const { success, message } = await hardDeleteUser(userId);

    if (!success) {
      toast.dismiss();
      toast.error(message || 'Došlo je do greške prilikom trajnog brisanja.');
    } else {
      setIsHardDeleteModalOpen(false);
      setMedics((prev) => prev.filter((user) => user._id !== userId));
      toast.dismiss();
      toast.success('Nalog je uspešno trajno obrisan.');

      if (activeTab === 'svi') loadMedics();
      else if (activeTab === 'clinic') loadClinics();

      setTimeout(() => {
        setHardDeleteUserId(null);
      }, 1000);
    }

    setIsHardDeleteLoading(false);
  };

  const handleActivateMedic = async () => {
    const userId = activateUserId;
    toast.loading('Aktiviranje...');

    setIsActivateLoading(true);
    const { success, message } = await activateMedic(userId);

    if (!success) {
      toast.dismiss();
      toast.error('Došlo je do greške prilikom aktivacije.');
    } else {
      setIsActivateModalOpen(false);
      setMedics((prev) =>
        prev.map((u) => (u._id === userId ? { ...u, status: 'ACTIVE' } : u))
      );
      toast.dismiss();
      toast.success('Mentor je uspešno aktiviran.');
      loadMedics();
      setTimeout(() => {
        setActivateUser(null);
      }, 1000);
    }

    setIsActivateLoading(false);
  };

  const clinicColumns = [
    {
      key: 'name',
      label: 'Organizacija',
      render: (val) => {
        return val || '';
      },
    },
    {
      key: 'email',
      label: 'Email',
      render: (val) => userTypeTranslations[val] || val,
    },
    {
      key: 'phone',
      label: 'Broj telefona',
      render: (val) => {
        return <span>{val ?? '-'}</span>;
      }
    },
    {
      // TODO:
      key: 'numberOfDoctors',
      label: 'Broj povezanih mentora',
      render: (val) => {
        return <span>{val}</span>;
      },
    },
    {
      // TODO:
      key: '2',
      label: 'Referral kod',
      render: (_, row) => {
        return (
          <span style={{ color: '#005844' }}>{row?.referralCode || '-'}</span>
        );
      },
    },
    {
      key: 'isActive',
      label: 'Status',
      render: (val, row) => {
        return (
          <span className={val ? 'active' : 'inactive'}>
            {val ? 'Aktivan' : 'Neaktivan'}
          </span>
        );
      },
    },
  ];

  const columns = [
    {
      key: 'firstName',
      label: 'Mentor',
      render: (_, row) => {
        const full_name = `${row.firstName || ''} ${row.lastName || ''}`;
        return full_name;
      },
    },
    {
      key: 'email',
      label: 'Email',
      render: (val) => userTypeTranslations[val] || val,
    },
    {
      key: 'phone',
      label: 'Broj telefona',
      render: (_, row) => {
        return row?.phone ?? '-';
      },
    },
    {
      key: 'clinic',
      label: 'Organizacija',
      render: (_, row) => {
        const name = (row && row?.clinic?.name) || '-';
        return <span className={name}>{name}</span>;
      },
    },
    {
      // TODO:
      key: '',
      label: 'Referral kod',
      render: (_, row) => {
        return (
          <span style={{ color: '#005844' }}>{row?.referralCode || '-'}</span>
        );
      },
    },
    {
      key: 'loyaltyPoints',
      label: 'Poeni',
      render: (val) => <span>{val ?? 0}</span>,
    },
    {
      key: 'status',
      label: 'Status',
      render: (val) => {
        const isActive = val && val.toUpperCase() === 'ACTIVE';
        return (
          <span className={isActive ? 'active' : 'inactive'}>
            {isActive ? 'Aktivan' : 'Deaktiviran'}
          </span>
        );
      },
    },
  ];

  const handleCopyLink = (item) => {
    toast.info('Kopirano u clipboard');
    const referralLink = item?.referralCode || 'Referral link';
    navigator.clipboard
      .writeText(referralLink)
      .then(() => {
        // TODO: Show notificaiton that is copied
      })
      .catch((err) => console.error(`Error: ${err}`));
  };

  const handleViewMedic = async (id) => {
    switch (activeTab) {
      case 'svi':
        navigate(`/medics/view/${id}`);
        break;
      case 'clinic':
        navigate(`/clinic/view/${id}`);
        break;
      default:
        break;
    }
  };

  const handleEditMedic = async (id) => {
    switch (activeTab) {
      case 'svi':
        navigate(`/medics/edit/${id}`);
        break;
      case 'clinic':
        navigate(`/clinic/edit/${id}`);
        break;
      default:
        break;
    }
  };

  const renderTable = (
    state,
    emptyState = {
      icon: '/assets/icons/no-users.svg',
      title: 'Trenutno nema korisnika',
    },
    showFilter = true
  ) => (
    <TableSection
      showFilter={showFilter}
      createButtonDisplay={state.createButtonDisplay}
      onCreateClick={state?.actionButton?.onClick}
      // onSearch={setSearch}
      filter={{
        selected: filter,
        sections: [getFilteredSections(activeTab)],
      }}
      onFilterChange={handleFilterChange}
      columns={state.columns}
      page={'medics'}
      actions={[
        {
          key: 'copy',
          label: 'Kopiraj referral link',
          icon: <img src="/assets/icons/copy.svg" alt="View" />,
          onClick: (item) => handleCopyLink(item),
          visible: (user) => user.status !== 'archived',
        },
        {
          // TODO:
          key: 'view',
          label: 'Vidi detalje',
          icon: <img src="/assets/icons/view-icon.svg" alt="Archive" />,
          onClick: (user) => handleViewMedic(user._id),
          visible: (user) => user.status !== 'archived',
        },
        {
          // TODO:
          key: 'block',
          label: 'Uredi nalog',
          icon: <img src="/assets/icons/edit-icon.svg" alt="Archive" />,
          onClick: (user) => handleEditMedic(user._id),
          visible: (user) => user.status !== 'archived',
        },
        {
          key: 'award-points',
          label: 'Dodaj poene',
          icon: <img src="/assets/icons/edit-icon.svg" alt="Award points" />,
          onClick: (u) => {
            setAwardPointsUser(u);
            setIsAwardPointsModalOpen(true);
          },
          visible: (u) => activeTab === 'svi' && u.status !== 'archived',
        },
        {
          key: 'deduct-points',
          label: 'Oduzmi poene',
          icon: <img src="/assets/icons/edit-icon.svg" alt="Deduct points" />,
          onClick: (u) => {
            setDeductPointsUser(u);
            setIsDeductPointsModalOpen(true);
          },
          visible: (u) => activeTab === 'svi' && u.status !== 'archived',
        },
        ...(canAll(['network:manage', 'scope:all'])
          ? [
              {
                key: 'deactivate',
                label: 'Deaktiviraj',
                icon: <img src="/assets/icons/delete.svg" alt="Deactivate" />,
                className: 'delete',
                onClick: (u) => {
                  setDeleteUser(u._id);
                  setDeleteUserName(`${u.firstName || ''} ${u.lastName || ''}`.trim());
                  setIsDeleteModalOpen(true);
                },
                visible: (u) =>
                  activeTab !== 'svi' || (u.status && u.status.toUpperCase() === 'ACTIVE'),
                danger: true,
              },
              {
                key: 'activate',
                label: 'Aktiviraj',
                icon: <img src="/assets/icons/view-icon.svg" alt="Activate" />,
                onClick: (u) => {
                  setActivateUser(u._id);
                  setActivateUserName(`${u.firstName || ''} ${u.lastName || ''}`.trim());
                  setIsActivateModalOpen(true);
                },
                visible: (u) =>
                  activeTab === 'svi' &&
                  u.status &&
                  u.status.toUpperCase() !== 'ACTIVE',
              },
            ]
          : []),
        ...(canAll(['users:delete', 'scope:all'])
          ? [
              {
                key: 'hard-delete',
                label: 'Trajno obriši nalog',
                icon: <img src="/assets/icons/delete.svg" alt="Delete" />,
                className: 'delete',
                danger: true,
                onClick: (u) => {
                  // The 'clinic' tab lists Clinic documents, not Users — the account to
                  // archive is the clinic's owner, not the clinic itself.
                  if (activeTab === 'clinic') {
                    const ownerId = u.owner || u.ownerData?._id;
                    setHardDeleteUserId(ownerId);
                    setHardDeleteUserName(
                      u.ownerData
                        ? `${u.ownerData.firstName || ''} ${u.ownerData.lastName || ''}`.trim() || u.name
                        : u.name
                    );
                  } else {
                    setHardDeleteUserId(u._id);
                    setHardDeleteUserName(`${u.firstName || ''} ${u.lastName || ''}`.trim());
                  }
                  setIsHardDeleteModalOpen(true);
                },
                visible: (u) =>
                  activeTab !== 'clinic' || !!(u.owner || u.ownerData?._id),
              },
            ]
          : []),
      ]}
      data={state.data}
      emptyState={emptyState}
      showPagination
      currentPage={state.currentPage}
      totalPages={state.totalPages}
      onPageChange={state.onPageChange}
      searchPlaceholder="Pretraži"
    />
  );

  const handleExport = async () => {
    let result;

    if (activeTab === 'svi') {
      result = await exportUsers({
        role: 'doctor',
        search: debouncedSearchMedics,
        status: filter.status
      });
    } else {
      result = await exportClinics({
        search: debouncedSearchClinic,
        status: filter.organizationStatus, 
      });
    }
    if (!result.success) {
      toast.error(result.message);
    } else if (result.data === null) {
      toast.info(result.message);
    } else {
      toast.success('Podaci uspešno izvezeni');
    }
  };
  
  console.log('acriveTab', activeTab);
  console.log('filter', filter);
  console.log('medics', medics);
  console.log('clinics', clinics);
  // console.log('current page', currentPage);

  const innerContent = (
    <>
      {!embedded && (
        <Tabs
          activeKey={activeTab}
          onChange={handleTabChange}
          items={tabItems}
          className="medics_tab"
        />
      )}

        {activeTab === 'svi' && (
          <>
            <div className={styles.totalCountRow}>
              <div className={styles.totalCount}>
                <span className={styles.totalCount__label}>Ukupno mentora</span>
                <span className={styles.totalCount__value}>
                  {new Intl.NumberFormat('de-DE').format(totalMedics)}
                </span>
                {(debouncedSearchMedics || filter.status) && (
                  <span className={styles.totalCount__hint}>(filtrirano)</span>
                )}
              </div>
            </div>
            <div className={`${styles.wrapper} users_wrapper`}>
              <div className={styles.filters}>
                <div className={styles.filters__left}>
                  <div>
                    <Search
                      placeholder={'Pretraži'}
                      className="search-input"
                      allowClear
                      enterButton
                      onChange={(e) => onSearchMedics(e.target.value)}
                      width="auto"
                    />
                  </div>
                  <Dropdown
                    menu={{
                      items: medicFilterOptions.map((option) => ({
                        key: option.value,
                        label: option.label,
                        onClick: () => {
                          setFilter((prev) => {
                            const updated = {
                              ...prev,
                              status: option.value,
                            };
                            return updated;
                          });
                        },
                      })),
                    }}
                    trigger={['click']}
                    placement="bottomLeft"
                    className={'btn-filter-container'}
                  >
                    <Button
                      className={`btn-tertiary btn-filter ${filter.status ? 'active' : ''}`}
                    >
                      {filter.status
                        ? `Status: ${
                            medicFilterOptions.find(
                              (option) => option.value === filter.status
                            )?.label
                          }`
                        : 'Status'}
                      {filter.status && (
                        <img
                          src="/assets/icons/x-gray.svg"
                          title="Ukloni filter status"
                          style={{
                            width: '10px',
                            height: '10px',
                            marginRight: '5px',
                            cursor: 'pointer',
                          }}
                          alt="Ukloni filter"
                          onClick={(e) => {
                            e.stopPropagation();
                            setFilter((prev) => {
                              const updated = { ...prev, status: null };
                              return updated;
                            });
                          }}
                        />
                      )}
                    </Button>
                  </Dropdown>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <Button
                      className={`btn-tertiary`}
                      onClick={handleExport}
                      icon={
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                          <path d="M8 12L3 7h3V1h4v6h3L8 12z"/>
                          <path d="M1 14h14v2H1z"/>
                        </svg>
                      }
                  >
                    Izvezi
                  </Button>
                  <Button
                    className={`btn-primary`}
                    type="primary"
                    onClick={() => setIsCreateMedicModalOpen(true)}
                  >
                    Dodaj mentora
                  </Button>
                </div>
              </div>
              <>
                {initialLoading ? <Spinner size="lg" /> : renderTable(
                  {
                    createButtonDisplay: 'Dodaj Mentora',
                    data: medics,
                    columns: columns,
                    onPageChange: setCurrentPageMedics,
                    currentPage: currentPageMedics,
                    totalPages: totalPagesMedics,
                  },
                  {
                    icon: '/assets/icons/no-users.svg',
                    title: 'Trenutno nema mentora',
                    description: 'Napravite mentora',
                  }
                )}
              </>

            </div>
          </>
        )}

        {activeTab === 'clinic' && (
          <>
            <div className={`${styles.wrapper} users_wrapper`}>
              <div className={styles.filters}>
                <div className={styles.filters__left}>
                  <div>
                    <Search
                      placeholder={'Pretraži'}
                      className="search-input"
                      allowClear
                      enterButton
                      onChange={(e) => onSearchClinics(e.target.value)}
                      width="auto"
                    />
                  </div>
                  <Dropdown
                    menu={{
                      items: organizationStatusOptions.map((option) => ({
                        key: option.value,
                        label: option.label,
                        onClick: () => {
                          setFilter((prev) => {
                            const updated = {
                              ...prev,
                              organizationStatus: option.value,
                            };
                            return updated;
                          });
                        },
                      })),
                    }}
                    trigger={['click']}
                    placement="bottomLeft"
                    className={'btn-filter-container'}
                  >
                    <Button
                      className={`btn-tertiary btn-filter ${filter.organizationStatus ? 'active' : ''}`}
                    >
                      {filter.organizationStatus
                        ? `Status: ${
                            organizationStatusOptions.find(
                              (option) =>
                                option.value === filter.organizationStatus
                            )?.label
                          }`
                        : 'Status'}
                      {filter.organizationStatus && (
                        <img
                          src="/assets/icons/x-gray.svg"
                          title="Ukloni filter status"
                          style={{
                            width: '10px',
                            height: '10px',
                            marginRight: '5px',
                            cursor: 'pointer',
                          }}
                          alt="Ukloni filter"
                          onClick={(e) => {
                            e.stopPropagation();
                            setFilter((prev) => {
                              const updated = {
                                ...prev,
                                organizationStatus: null,
                              };
                              return updated;
                            });
                          }}
                        />
                      )}
                    </Button>
                  </Dropdown>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <Button
                      className={`btn-tertiary`}
                      onClick={handleExport}
                      icon={
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                          <path d="M8 12L3 7h3V1h4v6h3L8 12z"/>
                          <path d="M1 14h14v2H1z"/>
                        </svg>
                      }
                  >
                    Izvezi
                  </Button>
                  <Button
                    className={`btn-primary`}
                    type="primary"
                    onClick={() => setIsCreateClinicModalOpen(true)}
                  >
                    Dodaj organizaciju
                  </Button>
                </div>
              </div>
              <>
                {initialLoading ? <Spinner size="lg" /> : renderTable(
                  {
                    createButtonDisplay: 'Dodaj organizaciju',
                    data: clinics,
                    columns: clinicColumns,
                    onPageChange: setCurrentPageClinics,
                    currentPage: currentPageClinics,
                    totalPages: totalPagesClinics,
                    // actionButton: {
                    //   label: 'Dodaj organizaciju',
                    //   onClick: () => setIsCreateClinicModalOpen(true),
                    //   className: 'btn-primary',
                    //   type: 'primary',
                    //   style: { margin: '16px auto 0px auto' },
                    // },
                  },
                  {
                    icon: '/assets/icons/no-users.svg',
                    title: 'Trenutno nema organizacija',
                    description: 'Napravite organizaciju',
                  }
                )}
              </>

            </div>
          </>
        )}

        {/* {activeTab === 'verifikacija' && (
          <TableSection
            onSearch={setSearch}
            showFilter={false}
            onFilterChange={handleFilterChange}
            showCreateButton
            onCreateClick={() => setIsCreateMedicModalOpen(true)}
            data={medics}
            columns={[
              { key: 'email', label: 'Mentor' },
              {
                key: 'email',
                label: 'Email',
                align: 'alignRight',
                render: (val) => userTypeTranslations[val] || val,
              },
              {
                key: 'action',
                label: 'Akcija',
                align: 'alignRight',
                customCell: (user) => (
                  <Button
                    className="btn-tertiary"
                    onClick={() => {
                      setUserForVerification(user._id);
                    }}
                  >
                    <span>Verifikuj</span>
                  </Button>
                ),
              },
            ]}
            emptyState={{
              icon: '/assets/icons/no-users.svg',
              title: 'Trenutno nema korisnika',
              description: 'Napravite korisnika',
              actionButton: {
                label: 'Dodaj korisnika',
                onClick: () => {
                  setIsCreateMedicModalOpen(true);
                },
                type: 'primary',
                style: { marginTop: 16 },
              },
            }}
            showPagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
            searchPlaceholder="Pretraži"
          />
        )} */}
    </>
  );

  return (
    <>
      {embedded ? innerContent : <ContentLayout>{innerContent}</ContentLayout>}
      <CreateMedicModal
        isOpen={isCreateMedicModalOpen}
        onClose={handleCreateMedicModalClose}
        onCreate={loadMedics}
        clinics={allClinics}
      />
      <CreateClinicModal
        isOpen={isCreateClinicModalOpen}
        onClose={handleCreateClinicModalClose}
        onCreate={loadClinics}
      />
      <DeleteModal
        visible={isDeleteModalOpen}
        onDelete={handleDeleteMedic}
        onCancel={handleDeleteModalClose}
        loading={isDeleteLoading}
        done={done}
        title={`${activeTab === 'svi' ? 'Deaktiviranje mentora' : 'Brisanje organizacije'}`}
        message={`${activeTab === 'svi' ? `Da li ste sigurni da želite da deaktivirate mentora ${deleteUserName}?` : 'Da li ste sigurni da želite da obrišete ovu organizaciju?'}`}
        buttonText={`${activeTab === 'svi' ? 'Deaktiviraj mentora' : 'Obriši organizaciju'}`}
        cancelText="Otkaži"
      />
      <DeleteModal
        visible={isActivateModalOpen}
        onDelete={handleActivateMedic}
        onCancel={() => setIsActivateModalOpen(false)}
        loading={isActivateLoading}
        title="Aktiviranje mentora"
        message={`Da li ste sigurni da želite da aktivirate mentora ${activateUserName}?`}
        buttonText="Aktiviraj mentora"
        cancelText="Otkaži"
      />
      <DeleteModal
        visible={isHardDeleteModalOpen}
        onDelete={handleHardDeleteMedic}
        onCancel={handleHardDeleteModalClose}
        loading={isHardDeleteLoading}
        title="Trajno brisanje naloga"
        message={`Da li ste sigurni da želite da trajno obrišete nalog ${hardDeleteUserName}? Nalog se ne može vratiti, email postaje slobodan za novu registraciju, a istorija porudžbina ostaje sačuvana.`}
        buttonText="Trajno obriši nalog"
        cancelText="Otkaži"
      />
      <AwardLoyaltyPointsModal
        onConfirm={handleAwardPoints}
        onClose={() => {
          setIsAwardPointsModalOpen(false);
          setAwardPointsUser(null);
        }}
        loading={loadingAwardPoints}
        userName={
          awardPointsUser
            ? `${awardPointsUser.firstName} ${awardPointsUser.lastName}`
            : ''
        }
        isOpen={isAwardPointsModalOpen}
      />
      <DeductLoyaltyPointsModal
        onConfirm={handleDeductPoints}
        onClose={() => {
          setIsDeductPointsModalOpen(false);
          setDeductPointsUser(null);
        }}
        loading={loadingDeductPoints}
        userName={
          deductPointsUser
            ? `${deductPointsUser.firstName} ${deductPointsUser.lastName}`
            : ''
        }
        isOpen={isDeductPointsModalOpen}
      />
      {/* <UserVerificationModal
        userId={userForVerification}
        visible={isUserVerificationModalOpen}
        onClose={handleVerifyUserModalClose}
        onVerify={handleVerifyCompanyUser}
        verifyLoading={loading}
        verifyDone={done}
        loadUsers={loadMedics}
      /> */}
      {/* <ToastContainer position="bottom-right" /> */}
    </>
  );
}

Medics.propTypes = {
  // When true, renders as a tab body (no own ContentLayout/Tabs switcher) — see
  // src/pages/korisnik/korisnici.js's Mentori/Organizacije tabs.
  embedded: PropTypes.bool,
  initialTab: PropTypes.oneOf(['svi', 'clinic']),
};
